import {
  saveLocalStorage,
  getToken,
  getLocalStorage
} from "components/Helper/Helper";
import { Config } from "../../../Config.js";
import axios from "axios";
import {
  SET_ALL_USERS,
  LOADER_STATUS,
  ON_NOTIFY,
  SET_CREATE_USER_MODAL,
  SET_Edit_USER_MODAL,
  GET_ALL_COMPANIES,
  TOTAL_RECORD,
  SET_USER_LAST_ACTIVITY,
  GET_ALL_GROUPS
} from "./constants";
import { toast } from "react-toastify";

export function setAllUsers(data) {
  return {
    type: SET_ALL_USERS,
    users: data
  };
}
export function totalRecord(val, recordVal) {
  return {
    type: TOTAL_RECORD,
    totalRecords: val,
    records: recordVal
  };
}

export function loader(status) {
  return {
    type: LOADER_STATUS,
    loaderStatus: status
  };
}

export function setCreateUserModal(status) {
  return {
    type: SET_CREATE_USER_MODAL,
    isModalActive: status
  };
}
export function setEditUserModal(status) {
  return {
    type: SET_Edit_USER_MODAL,
    isEditModalActive: status
  };
}

export function setAllCompanies(data) {
  return {
    type: GET_ALL_COMPANIES,
    payload: data
  };
}

export function setAllGroups(data) {
  return {
    type: GET_ALL_GROUPS,
    payload: data
  };
}

export function setUserLastActvtiy(data) {
  console.log(data)
  return {
    type: SET_USER_LAST_ACTIVITY,
    payload: data
  };
}



export function onNotify(status, msg) {
  return {
    type: ON_NOTIFY,
    status: status,
    msg: msg
  };
}

export const getAllUser = (searchstr, page, rowsPerPage, fromDate, toDate, statusFilter = null) => {
  let data = {
    searchstr: searchstr,
    role: getLocalStorage("role"),
    currentPage: page,
    recordLimit: rowsPerPage,
    fromDate: fromDate || null,
    toDate: toDate || null,
    statusFilter: statusFilter
  };

  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/getAllUsers`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails")
        }
      })
        .then((response) => {
          dispatch(loader(false));
          if (response.data.error != 1) {
            if(Array.isArray(response.data.data)&&response.data.data.length>0){
              dispatch(totalRecord(Math.ceil(response.data.data[0].total / 10),response.data.data[0].total));
              dispatch(setAllUsers(response.data.data));
            }
            else{
              dispatch(totalRecord(0,0));
              dispatch(setAllUsers([]));
            }
            
          } else {
            dispatch(setAllUsers([]));
          }
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          window.alert(error);
          reject(true);
        });
    });
  };
};

export const getAllCompanies = (id) => {
  let data = {
    currentPage: 1,
    recordLimit: 1000000,
    group_id: id,
  };
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/getAllCompanyNames`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails")
        }
      })
        .then((res) => {
          dispatch(loader(false));
          if (res.data.error == 0) {

            console.log("Entity response :: ", res.data.data);
            let formatted_response = res.data.data?.map((element) => {
              return {
                value: element.id,
                label: element.Company
              };
              // return {
              //   id: element.id,
              //   name: element.Company
              // };
            });
            dispatch(setAllCompanies(formatted_response));
            resolve(true);
          }
        })

        .catch((e) => {
          console.log(e);
          dispatch(loader(false));
          window.alert(e);
          reject(true);
        });
    });
  };
};
export const createUser = (data) => {
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}user/register`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails")

        }
      })
        .then((response) => {
          dispatch(loader(false));

          if (response.data.error == 0) {
            resolve(response.data.user_id)
            // dispatch(onNotify(true, response.data.data)); 
          } else {
            // toast.error(response.data.data, {
            //   position: "bottom-center",
            //   autoClose: 3000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true
            // });
            resolve(0)
            // console.log("response.data.data",response.data.data)
            dispatch(onNotify(false, response.data.data));

          }

        })
        .catch((error) => {
          dispatch(loader(false));
          window.alert(error);
          reject(true);
        });
    });
  };
};

export const createUserCompanyMapping = (data) => {
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/addCompanyUserMapping`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails")

        }
      })
        .then((response) => {
          dispatch(loader(false));

          if (response.data.error == 0) {
            dispatch(onNotify(true, response.data.message));
          } else {
            dispatch(onNotify(false, response.data.message));
          }
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          window.alert(error);
          reject(true);
        });
    });
  };
}

export const updateUser = (data) => {
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/updateUserDetailsById`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails")
        }
      })
        .then((response) => {
          dispatch(loader(false));
          if (response.data.error == 0) {
            dispatch(onNotify(true, response.data.data));
          } else {
            dispatch(onNotify(false, response.data.message));
          }
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          window.alert(error);
          reject(true);
        });
    });
  };
};

export const deletUserById = (userId) => {
  console.log("userId", userId);
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${Config.url}console/deleteUserById/${userId}`,
        headers: {
          token: getLocalStorage("loginDetails")
        }
      })
        .then((response) => {
          dispatch(loader(false));
          // toast.success(`User deleted successfully!!`, {
          //    position: "bottom-center",
          //     autoClose: 2000,
          //     hideProgressBar: false,
          //     closeOnClick: true,
          //     pauseOnHover: true,
          //     draggable: true
          // });

          if (response.data.error == 0) {
            dispatch(onNotify(true, response.data.data)); //'User Created Successfully'
          } else {
            dispatch(onNotify(false, response.data.data));
          }
          resolve(true);

          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          toast.error(`Operation Failed`, {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
          window.alert(error);
          reject(true);
        });
    });
  };
};

export const createCompany = (bodyFormData) => {
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/registerCompany`,
        headers: {
          token: getLocalStorage("loginDetails"),
          "Content-Type": "application/json"
        },
        data: bodyFormData
      })
        .then((response) => {
          dispatch(loader(false));
          if (response.data.error != 1) {
            toast.success(`Company added Successfully`, {
              position: "bottom-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true
            });
            resolve(true);
          } else {
            toast.error(`Error: ${response.data.data}`, {
              position: "bottom-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true
            });

            resolve(true);
          }
        })
        .catch((error) => {
          dispatch(loader(false));
          window.alert(error);
          reject(true);
        });
    });
  };
};


export const getUserLastActivity = (userId, page, pageLimit, str, startDate, endDate) => {
  return (dispatch) => {
    dispatch(loader(true));

    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/getuserlastactivity`,
        data: {
          userId: userId,
          page,
          pageLimit,
          str,
          startDate,
          endDate
        },
        headers: {
          token: getLocalStorage("loginDetails")
        }

      })
        .then((response) => {
          dispatch(loader(false));


          if (response.data.error == 0) {
            console.log(response.data?.totalRecords, "response in user")
            dispatch(setUserLastActvtiy(response.data.data))
            dispatch(
              totalRecord(
                Math.ceil(response.data?.totalRecords / 10),
                response.data.totalRecords
              )
            );
          } else {
            dispatch(onNotify(false, "something went wrong"));
          }
          resolve(true);

        })
        .catch((error) => {
          dispatch(loader(false));
          toast.error(`Operation Failed`, {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
          window.alert(error);
          reject(true);
        });
    });
  };
};

export const getAllUserbyStatus = (status, page) => {
  let data = {
    isActive: status,
    pageNumber: page,
    pageLimit: 10
  };




  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/getuserbystatus`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails")
        }
      })
        .then((response) => {
          dispatch(loader(false));
          if (response.data.error != 1) {
            console.log(response.data)

            let data = response.data.data.map((item, index) => {
              return {
                id: item.user_id,
                firstName: item.first_name,
                lastName: item.last_name,
                email: item.email,
                createdDate: new Date(item.created_date),
                isLoggdin: item.is_loggedIn,
                is_deleted: item.is_deleted,
                role: item.role == 0 ? "User" : "Admin",
                company: item.company,
                companyId: item.company_id,
                ip_address: item.ip_address && item.ip_address.length > 0 ? item.ip_address : []
              };
            });
            dispatch(
              totalRecord(
                Math.ceil(response.data?.totalRecords / 10),
                response.data.totalRecords
              )
            );
            dispatch(setAllUsers(data));
          } else {
            dispatch(setAllUsers([]));
          }
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          window.alert(error);
          reject(true);
        });
    });
  };
};


export const exportUserLastActivity = (userId, page, pageLimit, str, startDate, endDate) => {
  return (dispatch) => {
    dispatch(loader(true));

    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/downloaduserlastactivity`,
        data: {
          userId: userId,
          page,
          pageLimit,
          str,
          startDate,
          endDate
        },
        headers: {
          token: getLocalStorage("loginDetails")
        },
        responseType: "blob",


      })
        .then((response) => {
          dispatch(loader(false));


          if (response.data.error != 1) {
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a link element to trigger the download
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "userlastactivity.xlsx");

            // Append the link to the document body and trigger the download
            document.body.appendChild(link);
            link.click();

          } else {
            dispatch(onNotify(false, "something went wrong"));
          }
          resolve(true);

        })
        .catch((error) => {
          dispatch(loader(false));
          toast.error(`Operation Failed`, {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
          window.alert(error);
          reject(true);
        });
    });
  };
};

export const exportAllUser = (searchstr, page, fromDate, toDate, status = null) => {
  let data = {
    searchstr: searchstr,
    role: getLocalStorage("role"),
    currentPage: page,
    recordLimit: 99999,
    fromDate: fromDate,
    toDate: toDate,
    status: status
  };




  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/downloaduserlist`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails")
        },
        responseType: "blob",

      })
        .then((response) => {
          dispatch(loader(false));
          if (response.data.error != 1) {
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a link element to trigger the download
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "user.xlsx");

            // Append the link to the document body and trigger the download
            document.body.appendChild(link);
            link.click();

          } else {
            dispatch(onNotify(false, "something went wrong"));
          }
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          window.alert(error);
          reject(true);
        });
    });
  };
};



export const exportAllUserbyStatus = (status, page) => {
  let data = {
    isActive: status == "Active" ? 0 : 1,
    pageNumber: page,
    pageLimit: 99999
  };





  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/downloaduserbystatus`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails")
        },
        responseType: "blob",

      })
        .then((response) => {
          dispatch(loader(false));
          if (response.data.error != 1) {
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a link element to trigger the download
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "user.xlsx");

            // Append the link to the document body and trigger the download
            document.body.appendChild(link);
            link.click();

          } else {
            dispatch(onNotify(false, "something went wrong"));
          }
          resolve(true);
        })
        .catch((error) => {
          dispatch(loader(false));
          window.alert(error);
          reject(true);
        });
    });
  };
};

export const getAllGroupList = () => {
  let data = {
    str:"", 
    pageNo:1,
    pageLimit:100000000,
    fromDate:null,
    toDate:null,
    isDownload:false
  };
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/getGroup`,
        data: data,
        headers: {
          token: getLocalStorage("loginDetails")
        }
      })
        .then((res) => {
          dispatch(loader(false));
          if (res.data.error == 0) {

            console.log("group list", res.data)
            let formatted_response = res.data.data?.map((element) => {
              return {
                id: element.id,
                name: element.group_name
              };
            });
            dispatch(setAllGroups(formatted_response));
            resolve(true);
          }
        })

        .catch((e) => {
          console.log(e);
          dispatch(loader(false));
          window.alert(e);
          reject(true);
        });
    });
  };
};

//--------------------
export const getUserCount = (mode,year) => {
  return (dispatch) => {
    dispatch(loader(true));
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${Config.url}console/userOnBoardReport`,
        data: {
          mode,
          year
        },
        headers: {
          token: getLocalStorage("loginDetails")
        }

      })
        .then((response) => {
          dispatch(loader(false));
          if (response.data.error == 0) {
            resolve(response.data.data);  
          } else {
            resolve([]);  
          }
        })
        .catch((error) => {
          dispatch(loader(false));
          toast.error(`Operation Failed`, {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true
          });
          window.alert(error);
          reject(true);
        });
    });
  };
};